export default {
  events: null,
  selected: null,
  type: '',
  isAddingEvent: false
}
